<template>
    <div class="container pt-2">
        <PageTitle main="Cadastro de Novo orcamento" sub="Preencha o formulário abaixo para se cadastrar!" />
        <b-form>
            <input id="orcamento-id" type="hidden" v-model="orcamento.id" />
            <h3>Origem</h3>
            <div class="row">
                <div class="col-md-3">
                    <b-form-group label="CEP:" label-for="orcamento-origem_cep">
                        <b-form-input id="orcamento-origem_cep" type="text"
                            v-model="orcamento.origem_cep" 
                            placeholder="CEP"
                            v-mask="'#####-###'"
                            @keydown.tab="searchCepOrigem"
                            :class="{ 'inputError': $v.orcamento.origem_cep.$error }"
                            class="textInput"
                            />
                        <span class="error" v-if="!$v.orcamento.origem_cep.required && $v.orcamento.origem_cep.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.orcamento.origem_cep.minLength && $v.orcamento.origem_cep.$error">Digite um CEP completo!</span>
                    </b-form-group>
                </div>
                <div class="col-md-7">
                    <b-form-group label="Logradouro:" label-for="orcamento-origem_logradouro">
                        <b-form-input id="orcamento-origem_logradouro" type="text"
                            v-model="orcamento.origem_logradouro" 
                            placeholder="Informe o logradouro do orcamento."
                            :class="{ 'inputError': $v.orcamento.origem_logradouro.$error }"
                            class="textInput"
                            @keydown.tab="$v.orcamento.origem_logradouro.$touch"
                            />
                        <span class="error" v-if="!$v.orcamento.origem_logradouro.required && $v.orcamento.origem_logradouro.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.orcamento.origem_logradouro.minLength && $v.orcamento.origem_logradouro.$error">Precisa ter no mínimo 3 letras!</span>
                    </b-form-group>
                </div>
                <div class="col-md-2">
                    <b-form-group label="Número:" label-for="orcamento-origem_numero">
                        <b-form-input id="orcamento-origem_numero" type="text"
                            v-model="orcamento.origem_numero"
                            placeholder="Nº"
                            :class="{ 'inputError': $v.orcamento.origem_numero.$error }"
                            class="textInput"
                            @keydown.tab="$v.orcamento.origem_numero.$touch"
                            />
                        <span class="error" v-if="!$v.orcamento.origem_numero.required && $v.orcamento.origem_numero.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <b-form-group label="Complemento:" label-for="orcamento-origem_complemento">
                        <b-form-input id="orcamento-origem_complemento" type="text"
                            v-model="orcamento.origem_complemento"
                            class="textInput"
                            />
                    </b-form-group>
                </div>
                <div class="col-md-5">
                    <b-form-group label="Cidade:" label-for="orcamento-origem_cidade">
                        <b-form-input id="orcamento-origem_cidade" type="text"
                            v-model="orcamento.origem_cidade" 
                            placeholder="Informe o Cidade do orcamento."
                            :class="{ 'inputError': $v.orcamento.origem_cidade.$error }"
                            class="textInput"
                            @keydown.tab="$v.orcamento.origem_cidade.$touch"
                            />
                        <span class="error" v-if="!$v.orcamento.origem_cidade.required && $v.orcamento.origem_cidade.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group label="UF:" label-for="orcamento-origem_UF">
                        <b-form-select id="orcamento-origem_UF" :options="ufs" v-model="orcamento.origem_uf"
                        :class="{ 'inputError': $v.orcamento.origem_uf.$error }"
                        class="textInput"
                        @keydown.tab="$v.orcamento.origem_uf.$touch"
                        />
                        <span class="error" v-if="!$v.orcamento.origem_uf.required && $v.orcamento.origem_uf.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
            </div>
            <hr>
            <h3>Destino</h3>
            <div class="row">
                <div class="col-md-3">
                    <b-form-group label="CEP:" label-for="orcamento-destino_cep">
                        <b-form-input id="orcamento-destino_cep" type="text"
                            v-model="orcamento.destino_cep" 
                            placeholder="CEP"
                            v-mask="'#####-###'"
                            @keydown.tab="searchCepDestino"
                            :class="{ 'inputError': $v.orcamento.destino_cep.$error }"
                            class="textInput"
                            />
                        <span class="error" v-if="!$v.orcamento.destino_cep.required && $v.orcamento.destino_cep.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.orcamento.destino_cep.minLength && $v.orcamento.destino_cep.$error">Digite um CEP completo!</span>
                    </b-form-group>
                </div>
                <div class="col-md-7">
                    <b-form-group label="Logradouro:" label-for="orcamento-destino_logradouro">
                        <b-form-input id="orcamento-destino_logradouro" type="text"
                            v-model="orcamento.destino_logradouro" 
                            placeholder="Informe o logradouro do orcamento."
                            :class="{ 'inputError': $v.orcamento.destino_logradouro.$error }"
                            class="textInput"
                            @keydown.tab="$v.orcamento.destino_logradouro.$touch"
                            />
                        <span class="error" v-if="!$v.orcamento.destino_logradouro.required && $v.orcamento.destino_logradouro.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.orcamento.destino_logradouro.minLength && $v.orcamento.destino_logradouro.$error">Precisa ter no mínimo 3 letras!</span>
                    </b-form-group>
                </div>
                <div class="col-md-2">
                    <b-form-group label="Número:" label-for="orcamento-destino_numero">
                        <b-form-input id="orcamento-destino_numero" type="text"
                            v-model="orcamento.destino_numero"
                            placeholder="Nº"
                            :class="{ 'inputError': $v.orcamento.destino_numero.$error }"
                            class="textInput"
                            @keydown.tab="$v.orcamento.destino_numero.$touch"
                            />
                        <span class="error" v-if="!$v.orcamento.destino_numero.required && $v.orcamento.destino_numero.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <b-form-group label="Complemento:" label-for="orcamento-destino_complemento">
                        <b-form-input id="orcamento-destino_complemento" type="text"
                            v-model="orcamento.destino_complemento"
                            class="textInput"
                            />
                    </b-form-group>
                </div>
                <div class="col-md-5">
                    <b-form-group label="Cidade:" label-for="orcamento-destino_cidade">
                        <b-form-input id="orcamento-destino_cidade" type="text"
                            v-model="orcamento.destino_cidade" 
                            placeholder="Informe o Cidade do orcamento."
                            :class="{ 'inputError': $v.orcamento.destino_cidade.$error }"
                            class="textInput"
                            @keydown.tab="$v.orcamento.destino_cidade.$touch"
                            />
                        <span class="error" v-if="!$v.orcamento.destino_cidade.required && $v.orcamento.destino_cidade.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group label="UF:" label-for="orcamento-destino_UF">
                        <b-form-select id="orcamento-destino_UF" :options="ufs" v-model="orcamento.destino_uf"
                        :class="{ 'inputError': $v.orcamento.destino_uf.$error }"
                        class="textInput"
                        @keydown.tab="$v.orcamento.destino_uf.$touch"
                        />
                        <span class="error" v-if="!$v.orcamento.destino_uf.required && $v.orcamento.destino_uf.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
            </div>
            <hr>
            <div class="row mb-3">
                <div class="col-md-6">
                </div>
                <div class="col-md-6">
                    <b-form-checkbox v-model="selectCaminhao" name="chkCaminhao" switch>
                        Definir tipo de caminhão:
                    </b-form-checkbox>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                    <b-form-group label="Tipo de Carga:" label-for="orcamento-carga">
                        <b-form-select id="orcamento-carga" :options="cargas" v-model="orcamento.carga" 
                        :class="{ 'inputError': $v.orcamento.carga.$error }"
                        class="textInput"
                        @change="loadCaminhaos"
                        @keydown.tab="$v.orcamento.carga.$touch"/>
                        <span class="error" v-if="!$v.orcamento.carga.required && $v.orcamento.carga.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-6" v-if="selectCaminhao">
                    <b-form-group label="Tipo de Caminhão:" label-for="orcamento-caminhao">
                        <b-form-select id="orcamento-caminhao" :options="caminhaos" v-model="orcamento.caminhao" 
                        class="textInput"/>
                    </b-form-group>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                    <b-form-checkbox v-model="dataInicio" name="chkDtInicio" switch>
                        Definir data para Postagem:
                    </b-form-checkbox>
                </div>
                <div class="col-md-6">
                    <b-form-checkbox v-model="dataFinal" name="chkDtFinal" switch>
                        Definir data para Entrega:
                    </b-form-checkbox>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6" v-if="dataInicio">
                    <label for="orcamento-data_inicio">Data de Postagem:</label>
                    <b-form-datepicker 
                    id="orcamento-data_inicio" 
                    v-model="orcamento.data_inicio">
                    </b-form-datepicker>
                </div>
                <div class="col-md-6" v-else>
                </div>
                <div class="col-md-6" v-if="dataFinal">
                    <label for="orcamento-data_final">Data de Entrega:</label>
                    <b-form-datepicker 
                    id="orcamento-data_final" 
                    v-model="orcamento.data_final">
                    </b-form-datepicker>
                </div>
                <div class="col-md-6" v-else>
                </div>
            </div>
            <hr>

            <b-button variant="outline-success" class="mb-3 botaoInput" @click="save">Enviar</b-button>
            <b-button variant="outline-danger" class="ml-2 mb-3 botaoInput" @click="reset">Cancelar</b-button>
        </b-form>
    </div>
</template>

<script>

import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { mask } from 'vue-the-mask'
import { required, minLength } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'orcamentos',
    components: { PageTitle },
    directives: { mask },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            ufs: [
                { value: 'AC', text: 'Acre' },
                { value: 'AL', text: 'Alagoas' },
                { value: 'AP', text: 'Amapa' },
                { value: 'AM', text: 'Amazonas' },
                { value: 'BA', text: 'Bahia' },
                { value: 'CE', text: 'Ceará' },
                { value: 'DF', text: 'Distrito Federal' },
                { value: 'ES', text: 'Espirito Santo' },
                { value: 'GO', text: 'Goiás' },
                { value: 'MA', text: 'Maranhão' },
                { value: 'MT', text: 'Mato Grosso' },
                { value: 'MS', text: 'Mato Grosso do Sul' },
                { value: 'MG', text: 'Minas Gerais' },
                { value: 'PA', text: 'Para' },
                { value: 'PB', text: 'Paraíba' },
                { value: 'PR', text: 'Paraná' },
                { value: 'PE', text: 'Pernambuco' },
                { value: 'PI', text: 'Piauí' },
                { value: 'RJ', text: 'Rio de Janeiro' },
                { value: 'RN', text: 'Rio Grande do Norte' },
                { value: 'RS', text: 'Rio Grande do Sul' },
                { value: 'RO', text: 'Rondônia' },
                { value: 'RR', text: 'Roraima' },
                { value: 'SC', text: 'Santa Catarina' },
                { value: 'SP', text: 'São Paulo' },
                { value: 'SE', text: 'Sergipe' },
                { value: 'TO', text: 'Tocantins' }
            ],
            orcamento: {},
            orcamentos: [],
            carga: {},
            cargas: [],
            caminhao: {},
            caminhaos: [],
            dataInicio: false,
            dataFinal: false,
            selectCaminhao: false,
            level: '',
            quemRecebeu: '',
            nome: '',
            email: ''
        }
    },
    validations: {
        orcamento: {
            origem_cep: {
                required,
                minLength: minLength(8)
            },
            origem_cidade: {
                required
            },
            origem_uf: {
                required
            },
            origem_logradouro: {
                required,
                minLength: minLength(4)
            },
            origem_numero: {
                required
            },
            destino_cep: {
                required,
                minLength: minLength(8)
            },
            destino_cidade: {
                required
            },
            destino_uf: {
                required
            },
            destino_logradouro: {
                required,
                minLength: minLength(4)
            },
            destino_numero: {
                required
            },
            carga: {
                required
            }
        }
    },
    methods: {
        loadCargas() {
            const url = `${baseApiUrl}/backend/tipo_carga.php`
            axios.get(url).then(res => {
                if(res.data['dados']!=='Não há dados disponíveis'){
                    this.cargas = res.data.map(carga => {
                        return { ...carga, value: carga.id, text: carga.titulo }
                    })
                }else{
                    this.cargas.push({ value: 'null', text: 'Não há dados disponíveis' })
                }
            })
        },
        loadCaminhaos() {
            const url = `${baseApiUrl}/backend/caminhaoByCarga.php?carga=${this.orcamento.carga}`
            axios.get(url).then(res => {
                if(res.data['dados']!=='Não há dados disponíveis'){
                    this.caminhaos = res.data.map(caminhao => {
                        return { ...caminhao, value: caminhao.caminhao, text: caminhao.caminhao_titulo }
                    })
                }else{
                    this.cargas.push({ value: 'null', text: 'Não há dados disponíveis' })
                }
            })
        },
        searchCepOrigem () {
            this.$v.orcamento.origem_cep.$touch()
			if(this.orcamento.origem_cep.length == 9) {
				axios.get(`https://viacep.com.br/ws/${ this.orcamento.origem_cep }/json/`)
                .then( res => {
                    this.orcamento.origem_cidade = res.data.localidade
                    this.orcamento.origem_logradouro = res.data.logradouro
                    this.orcamento.origem_uf = res.data.uf
                    document.getElementById("orcamento-origem_logradouro").value = res.data.logradouro
                    document.getElementById("orcamento-origem_UF").value = res.data.uf
                    document.getElementById("orcamento-origem_cidade").value = res.data.localidade
                    document.getElementById("orcamento-origem_numero").focus()
                })
				.catch( error => console.log(error) )
			} else {
                document.getElementById("orcamento-origem_logradouro").value = ''
                document.getElementById("orcamento-origem_UF").value = ''
                document.getElementById("orcamento-origem_cidade").value = ''
            }
        },
        searchCepDestino () {
            this.$v.orcamento.destino_cep.$touch()
			if(this.orcamento.destino_cep.length == 9) {
				axios.get(`https://viacep.com.br/ws/${ this.orcamento.destino_cep }/json/`)
                .then( res => {
                    this.orcamento.destino_cidade = res.data.localidade
                    this.orcamento.destino_logradouro = res.data.logradouro
                    this.orcamento.destino_uf = res.data.uf
                    document.getElementById("orcamento-destino_logradouro").value = res.data.logradouro
                    document.getElementById("orcamento-destino_UF").value = res.data.uf
                    document.getElementById("orcamento-destino_cidade").value = res.data.localidade
                    document.getElementById("orcamento-destino_numero").focus()
                })
				.catch( error => console.log(error) )
			} else {
                document.getElementById("orcamento-destino_logradouro").value = ''
                document.getElementById("orcamento-destino_UF").value = ''
                document.getElementById("orcamento-destino_cidade").value = ''
            }
		},
        reset() {
            this.orcamento = {}
            this.orcamento.origem_cidade = ''
            this.orcamento.origem_logradouro = ''
            this.orcamento.origem_uf = ''
            document.getElementById("orcamento-origem_logradouro").value = ''
            document.getElementById("orcamento-origem_UF").value = ''
            document.getElementById("orcamento-origem_cidade").value = ''
            this.orcamento.destino_cidade = ''
            this.orcamento.destino_logradouro = ''
            this.orcamento.destino_uf = ''
            document.getElementById("orcamento-destino_logradouro").value = ''
            document.getElementById("orcamento-destino_UF").value = ''
            document.getElementById("orcamento-destino_cidade").value = ''
            this.$v.orcamento.$reset()
            this.$router.push({ path: '/' })
        },
        save() {
            this.$v.orcamento.$touch()
            this.orcamento.cliente = this.quemRecebeu
            if(!this.$v.orcamento.$error){
                axios['post'](`${baseApiUrl}/backend/orcamentos.php`, this.orcamento)
                    .then(() => {
                        // const tipo = `?tipo=novoorcamento`
                        // const destinoEmail = `&destinoEmail=${this.email}`
                        // const destinoNome = `&destinoNome=${this.nome}`
                        // axios.get(`${baseApiUrl}/backend/mailorcamento.php${tipo}${destinoEmail}${destinoNome}`).then({})

                        this.$toasted.global.defaultSuccess({ message : 'orcamento inserido com sucesso!' })
                        this.reset()
                        this.$router.push({ path: '/' })
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        loadOrcamento(orcamento) {
            this.orcamento = { ...orcamento }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.quemRecebeu = decodedToken['data'].id
                this.nome = decodedToken['data'].nome
                this.email = decodedToken['data'].email
            }
        }
    },
    mounted() {
        this.validaLogin()
        if (this.level !== 'cliente') {
            this.$router.push('/')
        }
        this.loadCargas()
    }
}
</script>

<style>
    
</style>